




















import { Component, Vue, Provide } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IProject } from '@/lib/interfaces';
import { getProject } from '@/services/api.service';

@Component
export default class Project extends Vue {
  public project: IProject | null = null;

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const project: IProject = await getProject(to.params.project_id);
    next((vm: Project) => {
      vm.project = project;
      vm.$socket.emit('joinRoom', project._id);
    });
  }

  private beforeRouteLeave(to: Route, from: Route, next: (vm?: any) => void) {
    this.$socket.emit('leaveRoom', from.params.project_id);
    next();
  }
}
